const MyIcon = (props) => {
    return <span className={`iconfont ${props.type} ${props.className}`} style={props.style}></span>;
};

export default MyIcon;
